import { TranslationsGetLanguageUseCase } from '@/core/domain/translation/usecases/translations-get-language.usecase';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import _ from 'lodash';

@Injectable({
    providedIn: 'root',
})
export class UrlService {
    constructor(
        private readonly getLanguageUseCase: TranslationsGetLanguageUseCase,
        private readonly translate: TranslateService,
    ) {}

    public format(resource: string): string {
        const currentLanguage = this.getLanguageUseCase.execute().language;
        const pathTranslation = this.translateUrl(resource.replace(/^\/+/, ''));
        return '/' + [currentLanguage, pathTranslation].join('/');
    }

    protected translateUrl(subPaths: string): string {
        const subPathsItems = subPaths.split('/');
        const newPaths: string[] = [];
        _.forEach(subPathsItems, (path: string) => {
            const keyTranslation = 'routes.' + path;
            const translation = this.translate.instant(keyTranslation);
            if (translation === keyTranslation) {
                newPaths.push(path);
            } else {
                newPaths.push(translation);
            }
        });
        return newPaths.join('/');
    }
}
